<template>
    <v-container fluid>
        <v-card>
            <v-container fluid>
                <v-row>
                    <v-col xs="12" sm="10" offset-sm="1">
                        <v-card-title
                            class="justify-center display-1 primary--text"
                        >
                            {{ $t("message.Welcome") }}
                        </v-card-title>
                        <div v-if="$can('readRegistrationsStatistics', 'home')">
                            <v-card-text>
                                <v-card>
                                    <v-container fluid>
                                        <v-row align="center" justify="center">
                                            <v-hover v-slot:default="{ hover }">
                                                <v-col
                                                    cols="12"
                                                    sm="6"
                                                    xl="3"
                                                    :class="{
                                                        'elevation-18 hovered':
                                                            hover,
                                                    }"
                                                >
                                                    <v-container fluid>
                                                        <v-row
                                                            align="center"
                                                            justify="center"
                                                        >
                                                            <v-col cols="2">
                                                                <v-avatar
                                                                    color="primary"
                                                                >
                                                                    <v-icon
                                                                        dark
                                                                        large
                                                                        >folder</v-icon
                                                                    >
                                                                </v-avatar>
                                                            </v-col>
                                                            <v-col cols="6">
                                                                <div
                                                                    class="title grey--text"
                                                                    v-html="
                                                                        $t(
                                                                            'message.TotalToday'
                                                                        )
                                                                    "
                                                                ></div>
                                                                <v-progress-linear
                                                                    color="primary"
                                                                    value="100"
                                                                ></v-progress-linear>
                                                            </v-col>
                                                            <v-col>
                                                                <span
                                                                    class="display-1 font-weight-bold"
                                                                >
                                                                    {{
                                                                        $store
                                                                            .getters
                                                                            .getHome
                                                                            .vandaag_total
                                                                    }}
                                                                </span>
                                                            </v-col>
                                                            <v-divider
                                                                vertical
                                                                v-show="!hover"
                                                            ></v-divider>
                                                        </v-row>
                                                    </v-container>
                                                </v-col>
                                            </v-hover>
                                            <v-hover v-slot:default="{ hover }">
                                                <v-col
                                                    cols="12"
                                                    sm="6"
                                                    xl="3"
                                                    :class="{
                                                        'elevation-18 hovered':
                                                            hover,
                                                    }"
                                                >
                                                    <v-container fluid>
                                                        <v-row
                                                            align="center"
                                                            justify="center"
                                                        >
                                                            <v-col cols="2">
                                                                <v-avatar
                                                                    color="green"
                                                                >
                                                                    <v-icon
                                                                        dark
                                                                        large
                                                                        >done</v-icon
                                                                    >
                                                                </v-avatar>
                                                            </v-col>
                                                            <v-col cols="6">
                                                                <span
                                                                    class="title grey--text"
                                                                    v-html="
                                                                        $t(
                                                                            'message.FinishedToday'
                                                                        )
                                                                    "
                                                                ></span>
                                                                <v-progress-linear
                                                                    color="green"
                                                                    :value="
                                                                        finishProgress
                                                                    "
                                                                ></v-progress-linear>
                                                            </v-col>
                                                            <v-col>
                                                                <span
                                                                    class="display-1 font-weight-bold"
                                                                >
                                                                    {{
                                                                        $store
                                                                            .getters
                                                                            .getHome
                                                                            .vandaag_finish
                                                                    }}
                                                                </span>
                                                            </v-col>
                                                        </v-row>
                                                    </v-container>
                                                </v-col>
                                            </v-hover>
                                            <v-hover v-slot:default="{ hover }">
                                                <v-col
                                                    cols="12"
                                                    sm="6"
                                                    xl="3"
                                                    :class="{
                                                        'elevation-18 hovered':
                                                            hover,
                                                    }"
                                                >
                                                    <v-container fluid>
                                                        <v-row
                                                            align="center"
                                                            justify="center"
                                                        >
                                                            <v-col cols="2">
                                                                <v-avatar
                                                                    color="red"
                                                                >
                                                                    <v-icon
                                                                        dark
                                                                        large
                                                                        >warning</v-icon
                                                                    >
                                                                </v-avatar>
                                                            </v-col>
                                                            <v-col cols="6">
                                                                <span
                                                                    class="title grey--text"
                                                                    v-html="
                                                                        $t(
                                                                            'message.DidNotShowToday'
                                                                        )
                                                                    "
                                                                ></span>
                                                                <v-progress-linear
                                                                    color="red"
                                                                    :value="
                                                                        noShowProgress
                                                                    "
                                                                ></v-progress-linear>
                                                            </v-col>
                                                            <v-col>
                                                                <span
                                                                    class="display-1 font-weight-bold"
                                                                >
                                                                    {{
                                                                        $store
                                                                            .getters
                                                                            .getHome
                                                                            .vandaag_noshow
                                                                    }}
                                                                </span>
                                                            </v-col>
                                                            <v-divider
                                                                vertical
                                                                v-show="!hover"
                                                            ></v-divider>
                                                        </v-row>
                                                    </v-container>
                                                </v-col>
                                            </v-hover>
                                            <v-hover v-slot:default="{ hover }">
                                                <v-col
                                                    cols="12"
                                                    sm="6"
                                                    xl="3"
                                                    :class="{
                                                        'elevation-18 hovered':
                                                            hover,
                                                    }"
                                                >
                                                    <v-container fluid>
                                                        <v-row
                                                            align="center"
                                                            justify="center"
                                                        >
                                                            <v-col cols="2">
                                                                <v-avatar
                                                                    color="info"
                                                                >
                                                                    <v-icon
                                                                        dark
                                                                        large
                                                                        >folder_open</v-icon
                                                                    >
                                                                </v-avatar>
                                                            </v-col>
                                                            <v-col cols="6">
                                                                <div>
                                                                    <span
                                                                        class="title grey--text"
                                                                        v-html="
                                                                            $t(
                                                                                'message.OpenToday'
                                                                            )
                                                                        "
                                                                    ></span>
                                                                    <v-progress-linear
                                                                        color="info"
                                                                        :value="
                                                                            openProgress
                                                                        "
                                                                    ></v-progress-linear>
                                                                </div>
                                                            </v-col>
                                                            <v-col>
                                                                <span
                                                                    class="display-1 font-weight-bold"
                                                                >
                                                                    {{
                                                                        $store
                                                                            .getters
                                                                            .getHome
                                                                            .vandaag_open
                                                                    }}
                                                                </span>
                                                            </v-col>
                                                        </v-row>
                                                    </v-container>
                                                </v-col>
                                            </v-hover>
                                        </v-row>
                                    </v-container>
                                </v-card>
                            </v-card-text>
                            <bar-chart
                                :chartData="barChartData"
                                :options="barChartOptions"
                            />
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-container>
</template>

<script>
import BarChart from "../components/home/BarChartComponent";
import { formatDate } from "../utils/dates";

export default {
    components: {
        BarChart,
    },
    data: () => ({
        welcomeText: "",
        total: [],
        noshow: [],
        finished: [],
        barChartOptions: {
            responsive: true,
            maintainAspectRatio: false,
        },
    }),
    async created() {
        await this.$store.dispatch("processHome");
        const { history } = this.$store.getters.getHome;
        if (history) {
            history.forEach(h => {
                this.finished.push(h.finished);
                this.noshow.push(h.noshow);
                this.total.push(h.total);
            });
        }
    },
    computed: {
        openProgress() {
            return (
                (this.$store.getters.getHome.vandaag_open /
                    this.$store.getters.getHome.vandaag_total) *
                100
            );
        },
        noShowProgress() {
            return (
                (this.$store.getters.getHome.vandaag_noshow /
                    this.$store.getters.getHome.vandaag_total) *
                100
            );
        },
        finishProgress() {
            return (
                (this.$store.getters.getHome.vandaag_finish /
                    this.$store.getters.getHome.vandaag_total) *
                100
            );
        },
        barChartData() {
            const labels = [];
            if (this.$store.getters.getHome.length !== 0) {
                this.$store.getters.getHome.history.forEach(h => {
                    labels.push(
                        `${h.date} (${this.dayFormat(
                            new Date(formatDate(h.date)).getDay()
                        )})`
                    );
                });
            }
            return {
                labels,
                datasets: [
                    {
                        label: this.$t("message.Total"),
                        backgroundColor: "#1976D2",
                        data: this.total,
                    },
                    {
                        label: this.$t("message.Finished"),
                        backgroundColor: "#4CAF50",
                        data: this.finished,
                    },
                    {
                        label: this.$t("message.DidNotShowUp"),
                        backgroundColor: "#F44336",
                        data: this.noshow,
                    },
                ],
            };
        },
    },
    methods: {
        dayFormat(dayIndex) {
            const days = [
                this.$t("message.Sunday"),
                this.$t("message.Monday"),
                this.$t("message.Tuesday"),
                this.$t("message.Wednesday"),
                this.$t("message.Thursday"),
                this.$t("message.Friday"),
                this.$t("message.Saturday"),
            ];
            return days[dayIndex];
        },
    },
};
</script>

<style>
.hovered {
    /* cursor: pointer; */
    border-radius: 20px;
}
</style>
